import {
  faCartPlus,
  faInfoCircle,
  faLayerGroup,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { cartPostAction, getCartItems } from "../../actions/cartAction";
import { getPatientNotification } from "../../actions/dashboardAction";
import { ERROR } from "../../constants/types/alertType";
import { getUserDetail } from "../../utils/helper";

const StoreItem = ({
  name,
  description,
  image,
  price,
  productId,
  category,
  weight,
  quantity,
}) => {
  const dispatch = useDispatch();
  const role = useSelector((state) => state.role.role);
  const cartItems = useSelector((state) => state.cart.activeCartItem);
  const [qty, setQty] = useState(1);
  const handleAddToCart = () => {
    if (cartItems.some((x) => x?.productId === productId)) {
      dispatch({
        type: ERROR,
        payload: "Product already in your cart",
      });
      return;
    }
    let roleId = role.val == 3 ? role.val : role.val == 4 ? role.val : 1;
    var params = {
      params: {
        action: "addCartItem",
        itemId: productId,
        itemType: 0,
        quantity: qty,
        roleId: roleId,
        token: getUserDetail()?.token,
      },
    };
    dispatch(
      cartPostAction(params, () => {
        dispatch(getCartItems(role.val));
        dispatch(getPatientNotification(role.val));
      })
    );
  };

  const getOptions = () => {
    let options = [];
    for (let index = 1; index <= parseInt(quantity); index++) {
      if (index > 5) break;
      options.push(<option value={index}>{index}</option>);
    }
    return options;
  };

  return (
    <div className="card-store">
      <div className="card-image">
        <img src={`${image}?${Math.random()}`} alt="prod-item" />
        {category && (
          <span className="card-badge">
            <FontAwesomeIcon icon={faLayerGroup} />
            <span>{category}</span>
          </span>
        )}
      </div>
      <div className="card-desc">
        <div>
          <p className="card-title">{name}</p>
          <p className="product-desc">{description}</p>
        </div>
      </div>
      <div className="card-action ">
        <p>
          {(parseFloat(price) * qty).toLocaleString("en-US", {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
            style: "currency",
            currency: "USD",
          })}
        </p>
        {parseInt(quantity) > 0 ? (
          <div className="d-flex justify-content-end align-items-center">
            <label className="qty">
              {" "}
              Qty:
              <select onChange={(e) => setQty(e.target.value)} value={qty}>
                {getOptions()}
              </select>
            </label>
            <button className="btn btn-orange" onClick={handleAddToCart}>
              {" "}
              <FontAwesomeIcon size="sm" icon={faCartPlus} /> Add to cart
            </button>
          </div>
        ) : (
          <div className=" out-of-stock">
            {" "}
            <FontAwesomeIcon size="sm" icon={faInfoCircle} /> Out of stock
          </div>
        )}
      </div>
    </div>
  );
};

export default StoreItem;
